import moment from 'moment';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import * as outputDataList from "@/assets/apitype/itemList";
import { CodeName, YM } from "@/store/common";

export interface RowData {
  TP: "item" | "maker" | "total",
  momcd1?: string | null,
  mondat?: number | null,

  mohano?: string | null,
  moline?: string | null,
  soukoCd?: string | null,
  itemCd?: string | null,
  maker?: string | null,
  item?: string | null,
  jan?: string | null,
  bl?: number | null,
  cs?: number | null,
  mohasu?: number | null,
  tanaban?: string | null,
  mostan?: number | null,
  moskin?: number | null,
  motkiy?: string | null,
  mosrkb?: string | null,
  isWarehousing?: string | null,
  smudat?: Date | string | null,
  szsmkg?: Date | string | null,

}
//summary
export interface RowSummary {
  /** 入庫予定日 */
  mondat?: Date | string | null,
  moskin1?: number | null,
  moskin2?: number | null,
  moskin3?: number | null,
  moskin?: number | null,
  count?: number | null,
}

//Page State
export type OutputDataWarehousingTmpState = {

  //倉庫
  centerList: CodeName[],
  //メーカー
  makerList: CodeName[],


  //検索する条件
  requestParams: outputDataList.RequestParam,
  //検索終了した条件
  retrievedID: string,

  progress: Record<string, unknown>,
  datas: RowData[],
  summaries: RowSummary[],

  errorMessage: string | null,
};

export const initialState: OutputDataWarehousingTmpState = {

  //倉庫
  centerList: [],
  //メーカー
  makerList: [],

  requestParams: null,
  retrievedID: null,

  progress: {},
  datas: [],
  summaries: [],

  errorMessage: null,
};

//Page Slice
const createSliceContent = (name: string) => createSlice({
  name: name,
  initialState,
  reducers: {
    setCenterList(state: OutputDataWarehousingTmpState, action: PayloadAction<CodeName[]>) {
      state.centerList = action.payload;
    },
    setMakerList(state: OutputDataWarehousingTmpState, action: PayloadAction<CodeName[]>) {
      state.makerList = action.payload;
    },
    //検索条件
    setRequestParams(state: OutputDataWarehousingTmpState, action: PayloadAction<outputDataList.RequestParam>) {
      state.requestParams = action.payload;
    },
    setRetrievedID(state: OutputDataWarehousingTmpState, action: PayloadAction<string>) {
      state.retrievedID = action.payload;
    },
    putProgress(state: OutputDataWarehousingTmpState, action: PayloadAction<string>) {
      const key = action.payload;
      const progressNew = { ...state.progress };
      progressNew[key] = true;
      state.progress = progressNew;
    },
    removeProgress(state: OutputDataWarehousingTmpState, action: PayloadAction<string>) {
      const key = action.payload;
      const progressNew = {};
      Object.keys(state.progress).forEach(k => {
        if (key != k) {
          progressNew[k] = true;
        }
      })
      state.progress = progressNew;
    },
    searched(state: OutputDataWarehousingTmpState, action: PayloadAction<{ datas: RowData[], summaries: RowSummary[] }>) {
      //計算
      let datas = action.payload.datas;
      let summaries = action.payload.summaries;

      datas = parseData(datas);
      summaries = parseSummary(summaries);

      state.datas = datas;
      state.summaries = summaries;
    },
    setDatasWarehousing(state: OutputDataWarehousingTmpState, action: PayloadAction<RowData[]>) {
      const datas = action.payload;
      Object.assign(state, {
        datasWarehousing: datas,
      });
    },
    setErrorMessage(state: OutputDataWarehousingTmpState, action: PayloadAction<string>) {
      state.errorMessage = action.payload;
    }
  },
});

export const parseData = (datas: RowData[]): RowData[] => {
  let tmp: number;
  //set No.
  datas.forEach((data) => {
    if (typeof data.bl === 'string') data.bl = parseFloat(data.bl);
    if (typeof data.cs === 'string') data.cs = parseFloat(data.cs);
    if (typeof data.mohasu === 'string') data.mohasu = parseFloat(data.mohasu);
    if (typeof data.mostan === 'string') data.mostan = parseFloat(data.mostan);
    if (typeof data.moskin === 'string') data.moskin = parseFloat(data.moskin);
    if (typeof data.szsmkg === 'string') {
      const szsmkg = moment(data.szsmkg, 'YYYYMMDD');
      data.szsmkg = szsmkg.isValid() ? szsmkg.utcOffset(0, true).toDate() : null;
    }
    if (typeof data.smudat === 'string') {
      const smudat = moment(data.smudat, 'YYYYMMDD');
      data.smudat = smudat.isValid() ? smudat.utcOffset(0, true).toDate() : null;
    }
  });
  return datas;
}

export const parseSummary = (datas: RowSummary[]): RowSummary[] => {
  let tmp: number;
  //set No.
  datas.forEach((data) => {
    if (typeof data.mondat === 'string') {
      const mondat = moment(data.mondat, 'YYYYMMDD');
      data.mondat = mondat.isValid() ? mondat.utcOffset(0, true).toDate() : null;
    }
    if (typeof data.moskin1 === 'string') data.moskin1 = parseFloat(data.moskin1);
    if (typeof data.moskin2 === 'string') data.moskin2 = parseFloat(data.moskin2);
    if (typeof data.moskin3 === 'string') data.moskin3 = parseFloat(data.moskin3);
    if (typeof data.moskin === 'string') data.moskin = parseFloat(data.moskin);
    if (typeof data.count === 'string') data.count = parseFloat(data.count);
  });
  return datas;
}


//Page Slice Export
export const outputDataWarehousingTmpSlice = createSliceContent("outputDataWarehousingTmp");
